import { Book } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from '../Icon.types';

const MenuBook: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <Book width={size} height={size} color={color} {...rest} />;

MenuBook.displayName = 'MenuBook';

export default MenuBook;
